import { useMutation } from '@tanstack/react-query';
import {
  BidvH2HService,
  SyncTransHistoryDto,
  SyncTransHistoryH2hEntity,
} from 'services/openapi';

export const useBidvSyncTransHistoryMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<SyncTransHistoryH2hEntity, Error, SyncTransHistoryDto>({
      mutationFn: (variables: SyncTransHistoryDto) =>
        BidvH2HService.bidvH2HControllerSyncTransHistory(variables),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
